import React from "react";
import { Navigate } from "react-router-dom";

import AuthenticationForm from "./authentication/AuthenticationForm";
import AuthShell from "./authentication/AuthShell";
import { useCurrentUser } from "../components/context/UserContext";
import LoadingScreen from "../components/LoadingScreen";
import { destinoSegunCuenta } from "../helpers/destino-sesion";

// El marco (panel de marca, glow, clearance del navbar) vive en AuthShell y lo
// comparten /recuperar-clave y /nueva-clave. Acá solo quedan los redirects.
function Authentication() {
  const { currentUser, loading } = useCurrentUser();

  if (loading) {
    return <LoadingScreen />;
  }

  // Con sesión, cada cuenta va a donde le toca. Antes todo `!has_access` iba a
  // /waiting-for-access: el que creó su cuenta, se fue a buscar sus papeles y
  // volvió al día siguiente aterrizaba en una pantalla sin un solo botón
  // (revisor de #878, 08-sep-2026). La regla vive en helpers/destino-sesion.js.
  if (currentUser) {
    return <Navigate to={destinoSegunCuenta(currentUser)} replace />;
  }

  return (
    <AuthShell>
      <AuthenticationForm />
    </AuthShell>
  );
}

export default Authentication;
